import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { ActionMenuComponent } from '../../../shared/components/action-menu/action-menu.component';

@Component({
  selector: 'app-news-card',
  standalone: true,
  imports: [SharedModule, ActionMenuComponent],
  templateUrl: './news-card.component.html',
  styleUrl: './news-card.component.scss',
})
export class NewsCardComponent {
  @Input() date!: string;
  @Input() title: string = '';
  @Input() imageUrl!: string;
  @Input() tags: string[] = ['News', 'Press Releases'];
  @Input() id!: string;

  @Input() index!: number;
  @Input() lastElement: boolean = false;
  @Input() menuOpenIndex: number = -1;

  @Output() openMenuEmitter: EventEmitter<void> = new EventEmitter();
  @Output() closeMenuEmitter: EventEmitter<void> = new EventEmitter();
  @Output() onDeleteNewsEmitter: EventEmitter<string> = new EventEmitter();
  @Output() loadMoreIfLastIndexEmitter: EventEmitter<void> = new EventEmitter();

  constructor(private readonly router: Router) {}

  openMenu() {
    this.openMenuEmitter.emit();
  }

  closeAllMenu() {
    this.closeMenuEmitter.emit();
  }

  onDeleteNews() {
    this.onDeleteNewsEmitter.emit(this.id);
  }

  loadMoreIfLastIndex() {
    this.loadMoreIfLastIndexEmitter.emit();
  }

  handleEditNews(id: string | number) {
    this.router.navigate(['/edit-news/' + id]);
  }
}
